// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"536":"3bfa44a4","720":"9428710b"}[chunkId] + ".chunk.js";
};